import { useCatalog } from "@/lib/catalog/context.tsx";
import { withTarget } from "@/lib/catalog/targetText.ts";
import { deriveTrack, presetFilters, TRACK_PRESETS } from "@/lib/filters/presets.ts";
import { setFilters, useFilters } from "@/state/filters.ts";
import styles from "./controls.module.css";

/**
 * The three named tracks, plus the Custom state you land in the moment you
 * touch anything else. Real radios so arrow keys work; the chip is the label.
 *
 * Custom is rendered as a disabled radio unless it's the live answer — it's a
 * readout of where you are, not somewhere you can choose to go.
 */
export function TrackPresets() {
  const filters = useFilters();
  const track = deriveTrack(filters);
  const target = useCatalog().target.shortTitle;

  return (
    <fieldset className={styles.field}>
      <legend className={styles.legend}>Track</legend>
      <div className={styles.presets}>
        {TRACK_PRESETS.map((preset) => (
          <label
            key={preset.id}
            className={`${styles.preset} ${track === preset.id ? styles.presetOn : ""}`}
          >
            <input
              type="radio"
              name="track"
              className={styles.srOnly}
              value={preset.id}
              checked={track === preset.id}
              onChange={() => setFilters(presetFilters(preset.id))}
            />
            <span className={styles.presetLabel}>{preset.label}</span>
          </label>
        ))}
        <label className={`${styles.preset} ${track === "custom" ? styles.presetOn : ""}`}>
          <input
            type="radio"
            name="track"
            className={styles.srOnly}
            value="custom"
            checked={track === "custom"}
            disabled={track !== "custom"}
            readOnly
          />
          <span className={styles.presetLabel}>Custom</span>
        </label>
      </div>
      <p className={styles.hint}>
        {track === "custom"
          ? "Your own track. Pick a preset above to start over."
          : withTarget(TRACK_PRESETS.find((p) => p.id === track)?.blurb ?? "", target)}
      </p>
    </fieldset>
  );
}
